'use client';
import React, { useState, useEffect } from 'react';
import Homep from '@/app/componenets/Homep';
import Hero from '@/app/services/city-tour/hero';
import Content from '@/app/services/city-tour/content';
import THirdSlider from '@/app/services/city-tour/thirdSlider';
import Ban from '@/app/services/city-tour/Banner';
import Distination from '@/app/services/city-tour/distination';
import LimoService from '@/app/services/city-tour/limoService';
import MainData from '@/app/data/MainState';
import Head from 'next/head';
import TawkTo from '../../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  console.log(MainData, params, 'hellllllll');
  const [image, setImage] = useState('consumercitytours');
  const [title, setTitle] = useState(
    'Best Option for Your Transportation Needs'
  );
  const [subtitle, setSubtitle] = useState(
    'Prestige Ride’s Guided City Tours:  '
  );
  const mapping = MainData?.find((p) => p?.link === params.statesPage);
  console.log(mapping, 'mapping');

  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.hero_image);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  console.log(image, 'iiiii');

  return (
    <div>
      <title>
        Hire Prestige Ride's Professional Car Service for City Tours
      </title>
      <meta
        name="description"
        content="At Prestige Ride, we offer exceptional car service with skilled chauffeurs for city
        tours. Enjoy your guided tour to discover the city's hidden gems."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/services/city-tour"
      />

      {/* <Try/> */}
      {/* <Hero /> */}
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      <Content />
      <THirdSlider />
      <Ban />
      <Distination />
      <LimoService />
      <Footer />
      {/* <Book/> */}
      {/* <Jfk/> */}
      {/* <LastSlider/> */}
      {/* <InnerText/> */}
    </div>
  );
}

export default page;
